import Snowflake from './Snowflake';

export default Snowflake;
